<script setup lang="ts">
import UniActivityLayout from '~kui/components/KUI/Unified/Layout/Activity/UniActivityLayout.vue';

import UnifiedNavigationIA from '~/components/Unified/IA/UnifiedNavigationIA.vue';
import UnifiedPublicBackButton from '~/components/Unified/IA/UnifiedPublicBackButton.vue';
import { provideIaBackFrame } from '~/composables/unified/useIaBackFrame';
import { provideImmersiveActivity, useImmersiveActivity } from '~/composables/unified/useImmersiveActivity';
import { useUnifiedLandingNav } from '~/composables/useUnifiedLandingNav';

/**
 * A public learn page's activity. Under the new information architecture a guest reads its overview
 * under the bar with the way back above it, as a signed-in student does in the coach shell, and the
 * activity takes the whole screen once started. Without it, the activity is the whole screen.
 */
const { iaNav, signInItem } = await useUnifiedLandingNav();
provideImmersiveActivity(iaNav.value);
const immersive = useImmersiveActivity();
provideIaBackFrame(computed(() => iaNav.value && !immersive.value));
</script>

<template>
  <div
    v-if="iaNav"
    class="flex flex-col bg-background"
    :class="immersive ? 'h-dvh' : 'min-h-dvh'"
  >
    <template v-if="!immersive">
      <div class="relative z-40">
        <UnifiedNavigationIA :sign-in-item="signInItem" />
      </div>
      <UnifiedPublicBackButton />
    </template>
    <main id="main-content" class="flex min-h-0 flex-1 flex-col">
      <slot />
    </main>
    <div id="learn-teleport" />
  </div>
  <UniActivityLayout v-else>
    <template #activity>
      <slot />
    </template>
  </UniActivityLayout>
</template>
